module.exports = __webpack_public_path__ + "1b6059b277cb4194423605bc7460d2f7.otf";